import { render, staticRenderFns } from "./Wires.vue?vue&type=template&id=8c38440e&"
import script from "./Wires.vue?vue&type=script&lang=js&"
export * from "./Wires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports